@if (isLoading) {
  <div class="overlay full">
    <p class="text-center">{{appStrings.pleaseWait}}</p>
    <mat-spinner id="productsLoader"></mat-spinner>
  </div>
}

@if (!isLoading) {
  <div class="nav">
    <div class="top-left">
      <a id="featuredProducts_backToDashboard" class="back-link" [routerLink]="['/tools/catalogs']">
        <span class="crm-industrial-font icon-back"></span> {{appStrings.link_backToDashboard}} </a>
        <h1>{{appStrings.products_featuredProducts}}</h1>
        <h5>{{totalRecords}} {{appStrings.products_tools}}</h5>
      </div>
      @if (featureProds) {
        <form [formGroup]="searchInput">
          <div class="searchProduct">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{appStrings.accounts_search}}</mat-label>
              <input matInput id="accountsSearchFields" formControlName="searchField">
              <span matSuffix class="crm-industrial-font icon-search"></span>
            </mat-form-field>
          </div>
        </form>
      }
    </div>
    @if (!isLoading) {
      <div class="product-list">
        @for (product of page; track product; let i = $index) {
          <div class="product-div">
            <a id="featuredProduct_{{index}}" [routerLink]="['/tools/product', product.catalogCode, product.productNumber]">
              <img class="img" [src]="product.image || noImage" alt="{{product.name}}" />
              <span class="product-name" ="product.name | safe: 'html'"></span>
            </a>
          </div>
        }
      </div>
    }
    <mat-paginator [id]="featuredProductsPaginator" [length]="totalRecords" [pageSize]="pageSize" [hidePageSize]="true"
      [showFirstLastButtons]="true" (page)="loadPage($event)" [pageIndex]="currentPage">
    </mat-paginator>
  }
  <ng-template #noProducts>
    <p>{{appStrings.noResults}}</p>
  </ng-template>